import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePostHog } from "posthog-js/react";

/** Track SPA route changes (React Router does not reload the page). */
export default function PosthogPageView() {
    const location = useLocation();
    const posthog = usePostHog();

    useEffect(() => {
        if (!posthog) return;
        posthog.capture("$pageview", {
            $current_url: window.location.href,
        });
    }, [location.pathname, location.search, posthog]);

    return null;
}
